import { BeforeAfterSlider } from "@/components/ui/before-after-slider";
import beforeScreenshot from "@/assets/before-screenshot.png";
import afterScreenshot from "@/assets/after-screenshot.png";

export const BeforeAfterDemo = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-8">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-foreground">Before & After Comparison</h1>
        <p className="text-muted-foreground">
          Drag the slider to compare the before and after images
        </p>
      </div>

      <div className="space-y-8">
        {/* First comparison */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Design Transformation</h2>
          <BeforeAfterSlider
            beforeImage={beforeScreenshot}
            afterImage={afterScreenshot}
            beforeAlt="Before design transformation"
            afterAlt="After design transformation"
            className="w-full h-[400px]"
          />
        </div>

        {/* Second comparison */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold">UI Enhancement</h2>
          <BeforeAfterSlider
            beforeImage={beforeScreenshot}
            afterImage={afterScreenshot}
            beforeAlt="Before UI enhancement"
            afterAlt="After UI enhancement"
            className="w-full h-[400px]"
          />
        </div>
      </div>

      <div className="text-center text-sm text-muted-foreground">
        <p>Replace the placeholder images with your actual before/after screenshots</p>
      </div>
    </div>
  );
};
